export var valuesHorizontalAlignment = ["Left", "Center", "Right"];
/*

*/ 
//# sourceMappingURL=HorizontalAlignment.js.map